// Mirrors backend/password_policy.py so users see the real rules before submitting.
export const PASSWORD_HINT = "Min 10 characters with an uppercase letter, a lowercase letter, a digit and a symbol.";

export function passwordError(pw) {
  if (!pw || pw.length < 10) return "Password must be at least 10 characters.";
  if (!/[A-Z]/.test(pw)) return "Password must contain at least one uppercase letter.";
  if (!/[a-z]/.test(pw)) return "Password must contain at least one lowercase letter.";
  if (!/\d/.test(pw)) return "Password must contain at least one digit.";
  if (!/[^A-Za-z0-9]/.test(pw)) return "Password must contain at least one symbol (e.g. !@#$%).";
  return "";
}
